module.exports = __webpack_public_path__ + "static/media/social.9aa211bd.jpg";